import { SelectOption } from '~/shared/utils/types';

export const AUTOSCALING_STATE_PARAM_KEY = 'autoscaling_state';

export const autoscaleToAutoscalingFilterMap: Record<string, SelectOption | null> = {
  as_state_on: { id: 'on', name: 'On', group: 'autoscalingState' },
  as_state_off: { id: 'off', name: 'Off', group: 'autoscalingState' },
  as_state_unsupported: { id: 'not_supported', name: 'Unsupported', group: 'autoscalingState' },
};

export type FilterStoredInURL = Omit<SelectOption, 'group'> & {
  group: SelectOption['group'] | 'autoscalingState';
};

export function createAutoscalingFilters(pendingAutoscaleState: string[]): SelectOption[] {
  return pendingAutoscaleState
    .map((state) => autoscaleToAutoscalingFilterMap[state])
    .filter((f): f is SelectOption => f !== null);
}

export function filterNonSpecificGroups(filters: FilterStoredInURL[]): SelectOption[] {
  return filters.filter((f) => {
    const isTagGroup = typeof f.group === 'string' && f.group.startsWith('tag:');
    return (
      f.group !== 'volumeId' &&
      f.group !== 'instanceId' &&
      f.group !== 'autoscalingState' &&
      !isTagGroup
    );
  });
}

export function combineFilters(
  baseApiFilters: SelectOption[],
  pendingVolumeTagFilters: SelectOption[],
  pendingInstanceFilters: SelectOption[],
  autoscalingFilters: SelectOption[]
): SelectOption[] {
  return [
    ...baseApiFilters,
    ...pendingVolumeTagFilters,
    ...pendingInstanceFilters,
    ...autoscalingFilters,
  ];
}
